var viewer_figure_rtlignore_default = {
  "figure": "Q6VNw"
};
export {
  viewer_figure_rtlignore_default as default
};
//# sourceMappingURL=viewer-figure.rtlignore-scss.js.map
